import { h } from "preact";
import { RoutableProps } from "preact-router";
import { OrderCreator } from "../../../components/OrderCreator";
import { mezosSIT } from "../../../data/serialNumberSearchExecs";
import "./styles.scss";

export function MezosSITOrder(props: RoutableProps & { id?: string }) {
    return <div class="mezos-sit-order-page">
        <OrderCreator id={props.id} orderTypes={mezosSIT.orderTypes} serialRegexes={mezosSIT.orderedExecs}/>
    </div>;
}
